import { useCallback, useState } from "react";

const normaliseErrorPath = (path) => String(path || "")
  .replace(/\[(\d+)\]/g, ".$1")
  .replace(/^data\./, "")
  .replace(/^\.+|\.+$/g, "");

export const clearValidationErrorsForPath = (errors, changedPath) => {
  if (!errors || typeof errors !== "object") return errors;
  const normalisedChangedPath = normaliseErrorPath(changedPath);
  if (!normalisedChangedPath) return errors;

  const entries = Object.entries(errors);
  const retainedEntries = entries.filter(([errorPath]) => {
    const normalisedErrorPath = normaliseErrorPath(errorPath);
    return normalisedErrorPath !== normalisedChangedPath &&
      !normalisedErrorPath.startsWith(`${normalisedChangedPath}.`) &&
      !normalisedChangedPath.startsWith(`${normalisedErrorPath}.`);
  });

  return retainedEntries.length === entries.length ? errors : Object.fromEntries(retainedEntries);
};

const useValidationErrors = (initialErrors = {}) => {
  const [errors, setErrors] = useState(initialErrors);
  const clearErrorsForPath = useCallback((path) => {
    setErrors((currentErrors) => clearValidationErrorsForPath(currentErrors, path));
  }, []);

  return { clearErrorsForPath, errors, setErrors };
};

export default useValidationErrors;
